import type { FluidErrorCode } from "./error-codes.js";
import { FLUID_ERROR_CODES } from "./error-codes.js";

/**
 * Error thrown when the user should be redirected to the lobby
 */
export class RedirectToLobbyError extends Error {
  readonly errorCode: FluidErrorCode;

  constructor(message: string, errorCode?: FluidErrorCode) {
    super(message);
    this.name = "RedirectToLobbyError";
    this.errorCode = errorCode || FLUID_ERROR_CODES.UNKNOWN;
    Object.setPrototypeOf(this, RedirectToLobbyError.prototype);
  }
}

/**
 * Error thrown when Fluid container recreation fails
 */
export class FluidRecreationError extends Error {
  readonly canRetry: boolean;
  readonly originalError?: Error;

  constructor(
    message: string,
    options?: { canRetry?: boolean; originalError?: Error }
  ) {
    super(message);
    this.name = "FluidRecreationError";
    this.canRetry = options?.canRetry ?? true;
    this.originalError = options?.originalError ?? new Error(message);
    Object.setPrototypeOf(this, FluidRecreationError.prototype);
  }
}
